(() => {
  const sections = document.querySelectorAll('[data-ultrasound]:not([data-observed])');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (document.querySelector('script[data-ultrasound-runtime]')) return;
      const script = document.createElement('script');
      script.src = entry.target.dataset.runtime;
      script.dataset.ultrasoundRuntime = 'true';
      script.onerror = () => { entry.target.dataset.scene = 'fallback'; };
      document.head.appendChild(script);
    });
  }, { rootMargin: '300px' });
  // Quando la scena e' pronta e ben visibile, l'animazione parte una volta da sola (mai con il movimento ridotto).
  const autoplay = section => {
    const play = section.querySelector('[data-ultrasound-play]');
    const scene = section.querySelector('[data-ultrasound-scene]');
    if (!play || !scene || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let seen = false, done = false;
    const start = () => {
      if (done || !seen || section.dataset.scene !== 'ready' || play.disabled) return;
      done = true; watcher.disconnect(); ready.disconnect();
      play.click();
    };
    const watcher = new IntersectionObserver(entries => { seen = entries[0].isIntersecting; start(); }, { threshold: .6 });
    const ready = new MutationObserver(start);
    // Se la persona usa i comandi prima, non parte nulla da solo.
    section.addEventListener('click', () => { done = true; }, { capture: true, once: true });
    watcher.observe(scene);
    ready.observe(section, { attributes: true, attributeFilter: ['data-scene'] });
  };
  sections.forEach(section => { section.dataset.observed = 'true'; observer.observe(section); autoplay(section); });
})();
